<template>
    <header>
      <div class="header">
        <div class="header__left">
          <img src="https://assets-cdn.signable.co.uk/images/signable-full-white.svg" v-if="!$store.state.logoURL" />
          <img :src="$store.state.logoURL"  v-else />
        </div>
        <div class="header__right">
          <h2 class="header__heading">{{ title }}</h2>
        </div>
      </div>
      <div :class="`header header--mobile ${isHidden ? 'header--hidden' : ''}`">
        <div class="header__item">
          <a class="header__action-item" href="javascript:;"
            @click="showSideBarInfo">
            <icon name="bars" height="25" width="25"></icon>
          </a>
        </div>
        <div class="header__item">
          <img src="https://assets-cdn.signable.co.uk/images/signable-full-white.svg" height="50" v-if="!$store.state.logoURL" />
          <img :src="$store.state.logoURL" height="50" v-else />
        </div>
        <div class="header__item">
          <a class="header__action-item float-right" href="javascript:;" @click="showHelp">
            <icon name="question-circle" height="25" width="25"></icon>
          </a>
        </div>
        <div class="header__title">{{ title }}</div>
      </div>
    </header>
</template>

<script>
export default {
  name: 'app-header',
  props: ['title'],
  data () {
    return {
      isHidden: false,
      scrollTop: 0
    }
  },
  mounted () {
    window.addEventListener('scroll', this.toggleHeader)
  },
  beforeUnmount () {
    window.removeEventListener('scroll', this.toggleHeader)
  },
  methods: {
    toggleHeader () {
      const currentScrollTop = window.scrollTop || window.scrollY
      if (currentScrollTop > this.scrollTop + 20) {
        this.isHidden = true
      } else if (currentScrollTop < (this.scrollTop - 20)) {
        this.isHidden = false
      }

      if (currentScrollTop === 0) {
        this.isHidden = false
      }

      this.scrollTop = currentScrollTop
    },
    showSideBarInfo () {
      this.$bus.$emit('showSideBarInfo')
    },
    showHelp () {
      this.$bus.$emit('openModal', 'helpModal')
      this.$bus.$emit('selectTab', 'is-this-legal')
    }
  }
}
</script>

<style lang="sass" scoped>
  @import '@/styles/component-utils.sass'
  .header
    position: fixed
    width: 100%
    top: 0
    z-index: 100
    transition: all .1s ease-in-out
    @include clearfix
    &--mobile
      top: 0
      display: none
    &__left
      float: left
      width: 25%
      background-color: $color-cta
      padding: $spacing-base
    &__right
      background-color: #fff
      padding: $spacing-base
      float: right
      width: 75%
    &__heading
      margin: 0
      line-height: 2.1
    img
      height: 50px
      width: auto
      display: block
      max-width: 100%
  @media screen and (max-width: $screen-size-large)
    .header
      display: none
      &--hidden
        top: -55px
      &--mobile
        display: block
        background-color: $color-main
        color: #fff
        .header__item
          width: 33.33%
          float: left
          img
            margin: 0 auto
            height: 35px
            margin-top: $spacing-small
        .header__action-item
          float: left
          padding: $spacing-base
          &:hover
            background-color: $color-main-dark
          svg
            display: block
            margin-right: 0
            color: #fff
        .header__title
          background-color: #fff
          float: left
          width: 100%
          text-align: center
          color: initial
          padding: $spacing-small 0
          font-weight: bold
</style>
